document.addEventListener('click', function (e) {
  if (e.target.matches('.tcqty-plus, .tcqty-minus')) {
    var wrap = e.target.closest('.tcqty-selector');
    var input = wrap.querySelector('.tcqty-input');
    var val = parseInt(input.value, 10) || 1;
    if (e.target.matches('.tcqty-plus')) {
      val += 1;
    } else {
      val = Math.max(1, val - 1);
    }
    input.value = val;
  }
});